// Долгий подъём сессии (создание, «продолжить разговор», перезапуск ⟳).
//
// Процесс claude стартует вместе с MCP-серверами; на нагруженном боксе это
// бывает дольше 15 с (обычного таймаута запроса), поэтому запросы подъёма ждут
// до минуты (api.ts, SESSION_TIMEOUT_MS). Чтобы минута не выглядела зависанием,
// пока запрос идёт дольше BOOT_HINT_AFTER_MS, плашка (shell/Toast) показывает,
// что происходит и сколько уже ждём.

import { create } from 'zustand'

export const BOOT_HINT_AFTER_MS = 3000

export interface BootJob {
  label: string
  since: number
}

interface BootState {
  jobs: Record<number, BootJob>
}

export const useBooting = create<BootState>(() => ({ jobs: {} }))

let seq = 0

export async function trackBoot<T>(label: string, work: Promise<T>): Promise<T> {
  const id = ++seq
  useBooting.setState((s) => ({ jobs: { ...s.jobs, [id]: { label, since: Date.now() } } }))
  try {
    return await work
  } finally {
    useBooting.setState((s) => {
      const jobs = { ...s.jobs }
      delete jobs[id]
      return { jobs }
    })
  }
}

/** Текст плашки: «поднимаю сессию · 12 с — запуск агента с MCP бывает до минуты». */
export function bootText(job: BootJob, now: number): string {
  const sec = Math.max(0, Math.round((now - job.since) / 1000))
  return `${job.label} · ${sec} с — запуск агента с MCP-серверами бывает до минуты`
}
